import styled from 'styled-components';

import MaterialIcon from '@/components/atom/MaterialIcon';
import { Tablet } from '@/styles/layout';
import theme from '@/styles/theme';
import { QnaDetailAffiliation } from '@/types/qna';

interface Props {
  affiliation: QnaDetailAffiliation;
  moveToHospitalDetail: (hospitalPid: string) => void;
}
const AnswererHospital = ({ affiliation, moveToHospitalDetail }: Props) => {
  return (
    <Wrapper>
      <Title>답변을 작성한 선생님에게 진료 예약하기</Title>
      <HospitalWrapper>
        <div>
          <HospitalImage
            src={affiliation.imageUrl ?? '/images/defaultHospital.png'}
          />

          <HospitalInfo>
            <h3>{affiliation.name}</h3>
            <p>{affiliation.address ?? ''}</p>
          </HospitalInfo>
        </div>
        <HospitalButton
          onClick={() => moveToHospitalDetail(affiliation.affiliationPid)}
        >
          병원 정보 보러가기
          <MaterialIcon name={'chevron_right'} color={theme.color.gray600} />
        </HospitalButton>
      </HospitalWrapper>
    </Wrapper>
  );
};

export default AnswererHospital;

const Wrapper = styled.div`
  padding-top: 24px;
`;

const Title = styled.h3`
  ${({ theme }) => `
    ${theme.typography.UI16SB};
    color: ${theme.color.gray700};
  `};
`;

const HospitalWrapper = styled.div`
  margin-top: 8px;
  padding: 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ theme }) => `
    border: 1px solid ${theme.color.gray100};
  `};

  @media screen and (max-width: ${Tablet}) {
    display: block;
  }

  & > div {
    display: flex;
    align-items: center;

    @media screen and (max-width: ${Tablet}) {
      display: block;
    }
  }
`;

const HospitalImage = styled.img`
  width: 96px;
  height: 96px;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 24px;

  ${({ theme }) => `
    border: 1px solid ${theme.color.gray50};
  `};

  @media screen and (max-width: ${Tablet}) {
    width: 100%;
    height: 128px;
    margin-right: 0;
  }
`;

const HospitalInfo = styled.div`
  align-items: center;

  ${({ theme }) => `
    h3 {
      ${theme.typography.UI17SB};
      color: ${theme.color.gray700};
    }

    p {
      ${theme.typography.UI12M};
      margin: 4px 0 12px;
      color: ${theme.color.gray300};
    }
  `};

  @media screen and (max-width: ${Tablet}) {
    display: block;
    margin: 24px 0;
  }

  @media screen and (min-width: ${Tablet}) {
    margin-right: 24px;
  }
`;

const HospitalBadge = styled.div`
  display: inline-flex;
  gap: 8px;
`;

const Badge = styled.div<{ primaryColor?: boolean }>`
  ${({ theme, primaryColor }) => `
    ${theme.typography.UI12M};
    color: ${primaryColor ? theme.color.primary500 : theme.color.blue500};
    background: ${primaryColor ? theme.color.primary100 : theme.color.blue100};
    border-radius: 4px;
    padding: 3px 8px;
  `};
`;

const HospitalButton = styled.button`
  display: flex;
  align-items: center;
  min-width: 160px;

  ${({ theme }) => `
    ${theme.typography.UI14SB};
    color: ${theme.color.gray600};
    background: ${theme.color.gray50};
    border-radius: 8px;
    padding: 10px 16px;
    cursor: pointer;
  `};

  span {
    margin-left: 8px;
  }

  &:hover {
    ${({ theme }) => `
      background: ${theme.color.gray100};
    `};
  }

  &:active {
    ${({ theme }) => `
      background: ${theme.color.gray200};
    `};
  }
`;
